module.exports = __webpack_public_path__ + "static/media/Window_Close_Icon.1f954590.svg";